import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageObject } from 'types';

import { useAppSelector } from 'redux/hooks';

import { BucketContext } from 'contexts';

import { useScaleColumns } from 'hooks/useScaleColumns';

import { Headline } from 'components/Headline';
import { Image } from 'components/Image';

type TechnicalHookProps = {
  scale?: string;
  accessories: string[];
  technologies: string[];
};

const useTechnicalData = (props: TechnicalHookProps) => {
  const { scale, accessories, technologies } = props;

  const [urls, urlsSet] = useState<ImageObject[]>();

  const columns = useScaleColumns({ scale });

  const { getUrl } = useContext(BucketContext);

  const { season, marketLine } = useAppSelector((state) => state.settings);

  const { t } = useTranslation();

  const accessoriesComponents = accessories?.map((item) => (
    <Headline
      fontFamily="LFT Zeno"
      color="borderLight"
      scale="s"
      key={item}
      textTransform="isFirstLetterUppercase"
    >
      {item}
    </Headline>
  ));

  const imageComponents = urls?.map((item) => (
    <Image asAutoSize key={item.id} source={item.url} alt={item.key} />
  ));

  useEffect(() => {
    if (season && marketLine) {
      Promise.all(technologies.map((item) => getUrl(`catalogue/products${item}`))).then(
        (url) => {
          if (url) {
            const urlIntoObject = url?.map(
              (item, index): ImageObject => ({
                id: index,
                key: item.key,
                url: item.url,
              })
            );

            urlsSet(urlIntoObject);
          }
        }
      );
    }
  }, [technologies, season, marketLine]);

  return {
    columns,
    t,
    accessoriesComponents,
    imageComponents,
  };
};

export { useTechnicalData };
